import { LayoutGrid } from "lucide-react";
import { useEffect, useState } from "react";

import BlocoRecolhivel from "./BlocoRecolhivel";
import { EVENTO_MODULOS } from "./useModulosLoja";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token") || ""}`, "Content-Type": "application/json" });

const MODULOS = [
  { chave: "mesas", nome: "Mesas", detalhe: "salão, comanda da mesa e pedido pelo QR da mesa" },
  { chave: "comandas", nome: "Comandas", detalhe: "conta em nome do cliente, sem mesa (vem desligado)" },
  { chave: "balcao", nome: "Balcão", detalhe: "venda rápida no caixa" },
  { chave: "totem", nome: "Totem", detalhe: "autoatendimento em tela cheia (aba própria no cabeçalho)" },
  { chave: "delivery", nome: "Delivery", detalhe: "Novo Pedido e tela de entregas" },
];

/** Módulos da loja (pedido do dono, 29/09/2026): desligado, some do cabeçalho
 *  e do menu "Módulos" para todo mundo da loja. Liga de novo a qualquer hora;
 *  nada é apagado. */
export default function ModulosPreferencias({ toast }) {
  const [ligados, setLigados] = useState(null);
  useEffect(() => {
    fetch(`${API_URL}/api/settings/modulos`, { headers: auth(), cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => setLigados(d?.ligados || { mesas: true, comandas: false, balcao: true, totem: true, delivery: true }))
      .catch(() => setLigados({ mesas: true, comandas: false, balcao: true, totem: true, delivery: true }));
  }, []);

  const alternar = async (m) => {
    const novo = !ligados[m.chave];
    const anterior = ligados;
    setLigados({ ...ligados, [m.chave]: novo });
    try {
      const r = await fetch(`${API_URL}/api/settings/modulos`, { method: "PUT", headers: auth(), body: JSON.stringify({ ligados: { [m.chave]: novo } }) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.detail || "Não foi possível salvar.");
      setLigados(d.ligados);
      window.dispatchEvent(new CustomEvent(EVENTO_MODULOS, { detail: d }));
      toast({ title: `${m.nome} ${novo ? "ligado" : "desligado"}`, description: novo ? "Voltou para o cabeçalho e o menu." : "Saiu do cabeçalho e do menu. Nada foi apagado." });
    } catch (e) {
      setLigados(anterior);
      toast({ title: "Erro ao salvar", description: e.message, variant: "destructive" });
    }
  };

  const fora = ligados ? MODULOS.filter((m) => !ligados[m.chave]).map((m) => m.nome) : [];
  const resumo = !ligados ? "Carregando…" : fora.length ? `Desligados: ${fora.join(", ")}` : "Mesas, Comandas, Balcão, Totem e Delivery ligados";
  return (
    <BlocoRecolhivel e2e="card-modulos-loja" icone={LayoutGrid} titulo="Módulos da loja" resumo={resumo} carregando={!ligados}>
      <p className="text-sm text-muted-foreground mb-2">
        Desligue o que a loja não usa: o módulo some do cabeçalho e do menu Módulos para todo mundo. Nada é apagado —
        é só ligar de novo.
      </p>
      <div className="grid gap-x-6 sm:grid-cols-2">
        {MODULOS.map((m) => {
          const ligado = !!ligados?.[m.chave];
          return (
            <div key={m.chave} className="flex items-center justify-between gap-3 py-2 border-t">
              <div className="min-w-0">
                <p className="text-sm font-medium">{m.nome}</p>
                <p className="text-xs text-muted-foreground">{m.detalhe}</p>
              </div>
              <button type="button" onClick={() => alternar(m)} disabled={!ligados} data-e2e={`sw-modulo-${m.chave}`}
                role="switch" aria-checked={ligado} aria-pressed={ligado}
                className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors ${ligado ? "bg-primary" : "bg-gray-300 dark:bg-gray-600"} disabled:opacity-50`}>
                <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${ligado ? "translate-x-6" : "translate-x-1"}`} />
              </button>
            </div>
          );
        })}
      </div>
    </BlocoRecolhivel>
  );
}
